<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_ii"></a><a id="page_iii"></a><a id="title"></a>Solving Tough Problems</h1>
<p class="subtitle"><em>A<span class="small">N</span> O<span class="small">PEN</span> W<span class="small">AY OF</span> T<span class="small">ALKING</span>, L<span class="small">ISTENING,<br/>AND</span> C<span class="small">REATING</span> N<span class="small">EW</span> R<span class="small">EALITIES</span></em></p>
<p class="author">Adam Kahane</p>
<p class="image"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?43d53d0e